module.exports = __webpack_public_path__ + "static/TiemposHeadline-LightItalic-44dbe43f91b39e2abe9416499e40560e.woff2";